import './App.css';
import React, { useCallback, createContext, useContext, useState, useEffect, useRef, useMemo } from 'react';
import { PodcastGrid } from './PodcastGrid';
import "./App.css";
import ComponenteAudio from './ComponenteAudio';
import ComponenteBuscaAudio from './ComponenteBuscaAudio';
import Howl from "react-howler";
import Modal from './Modal';
import Menu from "./Menu";
import AudioShare from './AudioShare';
import axios from 'axios';
import { FaWhatsapp } from "react-icons/fa";
import entregue from '../src/entregue.png'


import InputMask from "react-input-mask";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import { useSearchParams } from "react-router-dom";
import { useForm, Controller } from 'react-hook-form';

import AudioPlayer from "./AudioPlayer";

const useMountEffect = fun => useEffect(fun, []);

function Home2() {
    const [openIndex, setOpenIndex] = useState(null);
    const [currentTime, setCurrentTime] = useState(0); // Tempo atual do áudio

    // url teste local
    // const baseurl = `https://podcast.tibmacae.org.br/ApiDoador.php`;

    //url em produção
      const baseurl = `ApiDoador.php`;

    const [showCalendar, setShowCalendar] = useState(false);
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [especial, setEspecial] = useState(searchParams.get("especial"));
    const [busca, setBusca] = useState('');
    const [busca_transcricao, setBusca_transcricao] = useState('');
    const [data, setData] = useState('');
    const [tipo, setTipo] = useState('');

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenBusca, setIsModalOpenBusca] = useState(false);
    const [isModalOpenEntregue, setIsModalOpenEntregue] = useState(false);
    const [isModalOpenComentario, setIsModalOpenComentario] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const openModalBusca = () => {setIsModalOpenBusca(true); console.log('teste novo menu modal busca'); toggleSidebar();} 
    const openModalEntregue = () => {setIsModalOpenEntregue(true); toggleSidebar();} 
    const openModalComentario = () => {setIsModalOpenComentario(true); toggleSidebar();} 
    const closeModal = () => setIsModalOpen(false);
    const closeModalBusca = () => setIsModalOpenBusca(false);
    const closeModalEntregue = () => setIsModalOpenEntregue(false);
    const closeModalComentario = () => setIsModalOpenComentario(false);


    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isInstallable, setIsInstallable] = useState(false);

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const [orientation, setOrientation] = useState('');

    const [audiocarregado, setAudiocarregado] = useState(false);
    const [currentAudio, setCurrentAudio] = useState(null); // Mantém o áudio selecionado
    const audioRef = useRef(null); // Referência para o elemento <audio>

    const [audioPlay, setAudioPlay] = useState('');
    const [itemPlay, setItemPlay] = useState(null);

    const [rowData, setRowData] = useState([]);


    const [isSidebarVisible, setIsSidebarVisible] = useState(false);
    const [submenuvisible, setSubmenuvisible] = useState(false);


    
        const { setValue, register, handleSubmit, reset, control, formState,
            formState: { isSubmitSuccessful }, } = useForm({
                defaultValues: { palavra_transcricao: "", inicio: "", fim: "", tema: "", idpastor: "" }
                // resolver: yupResolver(schema),
                // validationSchema: fieldsValidationSchema
            });

            const myRef = useRef(null);

  

  

  const executeScroll = () => myRef.current.scrollIntoView();

  const handleLinkClick = (value) => {
    console.log('Valor recebido:', value);
    if(value == "buscapalavra")
        openModalBusca();
    else {
        receberDados(value);
    }
    
    // enviarParaTela(value);
    setOpenIndex(!openIndex);
    
    // setLinkValue(value); // Atualiza o estado ou faz algo com o valor
  };

  const toggleSubmenu = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Alterna entre abrir e fechar
  };


   useEffect(()=>{
          console.log('index: ', submenuvisible);
          if(!submenuvisible){
              toggleSubmenu();
          }
  
  
      },[submenuvisible]);


  useMountEffect(executeScroll);

    useEffect(() => {
        const handleResize = () => {

            console.log('resize');
            console.log(window.screen.orientation.type.split("-")[0]);
            setOrientation(window.screen.orientation.type.split("-")[0])

            executeScroll();

            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        // Adiciona o listener de resize
        window.addEventListener('resize', handleResize);

        // Remove o listener ao desmontar o componente
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => {

            console.log('resize');
            console.log(window.screen.orientation.type.split("-")[0]);
            setOrientation(window.screen.orientation.type.split("-")[0]);

            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        
        window.addEventListener('load', handleResize);

       
        return () => window.removeEventListener('load', handleResize);
    }, []);

    


    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault(); // Evita o prompt automático do navegador
            setDeferredPrompt(e); // Armazena o evento para uso posterior
            setIsInstallable(true); // Ativa o botão de instalação
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const playAudio = async (audioSrc) => {
        // Atualiza o áudio atual
        setCurrentAudio(audioSrc);        
        // Reinicia o player após atualizar o src
        if (audioRef.current) {
            audioRef.current.load(); // Recarrega o áudio
            audioRef.current.play().catch((err) => console.error("Erro ao reproduzir:", err));
        }
    };   

    async function salvarLog(tipolog, id_palavra = null) {

        try {

            const config = {
                method: 'post',                
                url: baseurl,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 10000,
                data: {
                    'id': '',
                    'id_palavra': id_palavra,
                    'tipolog': tipolog,
                    'action': 'salvarlog'
                }
            };

            const req = await axios(config).then((res) => {
                console.log(res);                
            }).catch((err) => {
                // optionsPastores();
            });
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('A solicitação foi cancelada devido a timeout');
                //   optionsPastores();
                // Aqui você pode fazer algo, como tentar novamente a consulta
                // ou exibir uma mensagem de erro para o usuário
            } else {
                // Lidar com outros erros de rede ou do servidor
                console.error('Erro:', error.message);
                throw error;
            }

        }

    }   
    
    // const AudioPlayer = () => {
    //     const audioRef = useRef(null);
    //     const [currentTime, setCurrentTime] = useState(0);
      
    //     useEffect(() => {
    //       const audio = audioRef.current;
    //       if (audio) {
    //         audio.currentTime = currentTime; // Retorna para o tempo salvo
    //         audio.play();
    //       }
    //     }, []); // Executa apenas na montagem do componente
      
    //     const handleTimeUpdate = () => {
    //       setCurrentTime(audioRef.current.currentTime);
    //     };
      
    //     return (
    //       <audio
    //         ref={audioRef}
    //         src={currentAudio}
    //         controls
    //         onTimeUpdate={handleTimeUpdate} // Salva o tempo de reprodução
    //       />
    //     );
    //   };

      
    const AdvancedAudioPlayer = () => {

        const [isPlaying, setIsPlaying] = useState(audiocarregado);
        
        const [duration, setDuration] = useState(0); // Duração total do áudio
        
        const [progress, setProgress] = useState(0);
        const [volume, setVolume] = useState(1);
        // const audioRef = useRef(null);

        useEffect(() => {
            const audio = audioRef.current;
            if (audio) {
              audio.currentTime = currentTime; // Retorna para o tempo salvo
              audio.play();
            }
          }, []); // Executa apenas na montagem do componente
        

        const handleTimeUpdate = () => {
            setCurrentTime(audioRef.current.currentTime);
            if (audioRef.current) {
                // const currentTime = audioRef.current.currentTime;
                // const duration = audioRef.current.duration;
                setProgress((currentTime / duration) * 100);
            }
        };

        const handleLoadedMetadata = () => {
            if (audioRef.current) {
                setDuration(audioRef.current.duration); // Obtém a duração total do áudio
            }
        };

        // const [duration, setDuration] = useState(0);

        const audioContextRef = useRef(null); // Referência para o AudioContext
        const sourceNodeRef = useRef(null); // Referência para o MediaElementSourceNode
        const gainNodeRef = useRef(null); // Referência para o GainNode


        const handlePlayPause = () => {

            if (audioRef.current.paused) {
                audioRef.current.play();
            } else {
                audioRef.current.pause();
            }
        };
        
        const handleSeek = (event) => {

            const seekTo = parseFloat(event.target.value);
            console.log((event.target.value / 100) * audioRef.current.duration);
            setProgress(seekTo);
            if (audioRef.current) {
                audioRef.current.currentTime = (event.target.value / 100) * audioRef.current.duration;
                // audioRef.current.seek(seekTo);
            }
            // const seekTime = (event.target.value / 100) * audioRef.current.duration;
            // audioRef.current.currentTime = seekTime;
            // setProgress(event.target.value);
        };

        const handleVolumeChange = (event) => {
            const newVolume = event.target.value;
            setVolume(newVolume);
            audioRef.current.volume = newVolume;
        };

        const handleStop = () => {
            setIsPlaying(false);
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0; // Reinicia o áudio
            }
        };


        const setupEqualizer = (audioContext, source) => {
            const frequencies = [60, 170, 350, 1000, 3500, 10000]; // Graves a agudos
            const filters = frequencies.map((freq) => {
                const filter = audioContext.createBiquadFilter();
                filter.type = "peaking"; // Tipo de filtro para equalização
                filter.frequency.value = freq; // Freqüência central
                filter.Q.value = 1; // Controle da largura da banda
                filter.gain.value = 0; // Ganho inicial
                return filter;
            });

            // Conectar os filtros em série
            filters.reduce((prev, curr) => {
                prev.connect(curr);
                return curr;
            });

            // Conectar a saída do último filtro
            filters[filters.length - 1].connect(audioContext.destination);

            // Conectar o source ao primeiro filtro
            source.connect(filters[0]);

            return filters; // Retorna os filtros para controle
        };        

        const setupNoiseReduction = (audioContext, source) => {
            const highPass = audioContext.createBiquadFilter();
            highPass.type = "highpass";
            highPass.frequency.value = 10; // Remove sons abaixo de 100 Hz (ruído grave)

            const lowPass = audioContext.createBiquadFilter();
            lowPass.type = "lowpass";
            lowPass.frequency.value = 15000; // Remove sons acima de 15 kHz (ruído agudo)

            // Conectar os filtros em cadeia
            source.connect(highPass).connect(lowPass).connect(audioContext.destination);
        };

        const setupCompressor = (audioContext, source) => {
            const compressor = audioContext.createDynamicsCompressor();
            compressor.threshold.value = -30; // Nível de ativação (dB)
            compressor.knee.value = 40; // Curvatura da compressão
            compressor.ratio.value = 12; // Taxa de compressão
            compressor.attack.value = 0.01; // Tempo para começar a comprimir
            compressor.release.value = 0.25; // Tempo para parar de comprimir

            // Conectar o compressor
            source.connect(compressor).connect(audioContext.destination);
        };

        const setupReverb = async (audioContext, source) => {
            const convolver = audioContext.createConvolver();
            const response = await fetch("/reverb-impulse-response.wav"); // Arquivo de resposta de impulso
            const arrayBuffer = await response.arrayBuffer();

            // Decodifica o arquivo de resposta de impulso
            const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

            // Define o buffer no ConvolverNode
            convolver.buffer = audioBuffer;

            source.connect(convolver).connect(audioContext.destination);
        };

        const setupPanning = (audioContext, source) => {
            const panner = audioContext.createStereoPanner();
            panner.pan.value = 0; // -1 para esquerda, 1 para direita, 0 para centro

            source.connect(panner).connect(audioContext.destination);
        };

        const handleSkip = (seconds) => {
            const newTime = Math.min(
              Math.max(audioRef.current.currentTime + seconds, 0),
              duration
            );
            audioRef.current.currentTime = newTime;
            setProgress(newTime);
          };

        useEffect(() => {
            
            if (audioRef.current) {

                console.log('teste erro audio');

                

                // Criar o AudioContext apenas uma vez
                if (!audioContextRef.current) {
                    // audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
                    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)({
                        sampleRate: 96000, // Reamostra o áudio para 48 kHz
                    });
                }                

                // Criar o MediaElementSourceNode apenas uma vez
                if (!sourceNodeRef.current) {
                    // Conectar o <audio> ao AudioContext
                    // sourceNodeRef.current = audioContextRef.current.createMediaElementSource(audioRef.current);

                    const sourceNode = audioContextRef.current.createMediaElementSource(audioRef.current);

                    // Criar o GainNode para controle de volume
                    gainNodeRef.current = audioContextRef.current.createGain();

                    const analyser = audioContextRef.current.createAnalyser();
                    const gainNode = audioContextRef.current.createGain();

                    // Conectar os nós: MediaElementSourceNode -> GainNode -> Destination
                    // sourceNodeRef.current.connect(gainNodeRef.current).connect(audioContextRef.current.destination);

                    sourceNode.connect(analyser); // Conectar ao analisador
                    analyser.connect(gainNode).connect(audioContextRef.current.destination); // Saída final

                    sourceNodeRef.current = { sourceNode, analyser, gainNode };

                    // Analisar o volume
                    const dataArray = new Uint8Array(analyser.frequencyBinCount);
                    analyser.getByteFrequencyData(dataArray);

                    // Calcular o volume médio
                    const averageVolume = dataArray.reduce((sum, value) => sum + value, 0) / dataArray.length || 1; // Evitar NaN

                    // Ajustar o ganho (volume desejado)
                    const targetVolume = 5; // Meta de volume
                    gainNode.gain.value = targetVolume / averageVolume;

                    // setupEqualizer(audioContextRef.current, sourceNode);
                    // No seu código principal:
                    const filters = setupEqualizer(audioContextRef.current, sourceNodeRef.current.sourceNode);
                    // Ajustar as frequências dinamicamente:
                    filters[0].gain.value = 20; // Aumentar os graves, por exemplo

                    setupNoiseReduction(audioContextRef.current, sourceNodeRef.current.sourceNode);

                    setupCompressor(audioContextRef.current, sourceNodeRef.current.sourceNode);

                    // setupReverb(audioContextRef.current, sourceNodeRef.current.sourceNode);

                    setupPanning(audioContextRef.current, sourceNodeRef.current.sourceNode);                       

                    // Configurar o volume inicial
                    //gainNodeRef.current.gain.value = 20; // Volume padrão (1 = 100%)
                }
            }
            //};

            // normalizeVolume();
        }, [currentAudio]);


        const audioSrc = "path-to-your-audio-file.mp3"; // Substitua pelo caminho do seu arquivo de áudio
        const url = "https://podcast.tibmacae.org.br/?id="

        const handleShareToWhatsApp = () => {
            const message = encodeURIComponent(
                `Confira a esta pregação abençoada: \n ${itemPlay.tema} \n ${url}${itemPlay.id}`
            );
            const whatsappUrl = `https://wa.me/?text=${message}`;
            window.open(whatsappUrl, "_blank"); // Abre o link do WhatsApp em uma nova aba
        };

        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                maxWidth: "100%",
                justifyContent: 'center',
                alignItems: 'center',
                margin: "0 auto",
                textAlign: "center"
            }}>



                <p className='title_audio_executando'><b>Tema:</b> {itemPlay.tema}</p>

                <div className='buttoncontrols'>
                    {/* <button className='audiobutton' onClick={handlePrev}>⏮️</button> */}
                    <button className='audiobutton' onClick={() => handleSkip(-5)}>⏪ 5s</button>
                    <button className='audiobutton' onClick={handlePlayPause}>
                        {isPlaying ? "⏸️ Pausar" : "▶️ Tocar"}
                    </button>
                    <button className='audiobutton' onClick={handleStop}>⏹️ Parar</button>
                    {/* <button className='audiobutton' onClick={handleNext}>⏭️</button> */}
                    <button className='audiobutton' onClick={() => handleSkip(5)}>⏩ 5s</button>
                    
                </div>

                {windowSize.width > 480 ? 
                <div className='audio-container'>
                    <audio
                        controls
                        ref={audioRef}
                        src={currentAudio}
                        autoPlay
                        onLoad={() => setDuration(audioRef.current.duration())}

                        onLoadedMetadata={handleLoadedMetadata} // Obtém a duração do áudio
                        // controls
                        onTimeUpdate={handleTimeUpdate}
                    />
                    {/* <div style={{ marginTop: "10px", display: "flex", justifyContent: "center", gap: "10px" }}> */}

                    {/* Botão de compartilhar no WhatsApp */}
                    <button
                        onClick={handleShareToWhatsApp}
                        style={{
                            backgroundColor: "#25D366",
                            color: "white",
                            border: "none",
                            borderRadius: "50px",
                            padding: "10px 15px",
                            fontSize: "16px",
                            cursor: "pointer",
                            display: "flex",                            
                            alignItems: "center",
                            gap: "5px",
                        }}
                    >
                        <FaWhatsapp size={20} />

                    </button>
                    {/* </div> */}
                </div>

                :
                <div className='audio-container-menor'>
                    <audio
                        controls
                        ref={audioRef}
                        src={currentAudio}
                        autoPlay
                        onLoad={() => setDuration(audioRef.current.duration())}

                        onLoadedMetadata={handleLoadedMetadata} // Obtém a duração do áudio
                        // controls
                        onTimeUpdate={handleTimeUpdate}
                    />
                    <div className='div-compartilhar-menor'>
                        <p>Compartilhar</p>
                    <button
                        onClick={handleShareToWhatsApp}
                        style={{
                            backgroundColor: "#25D366",
                            color: "white",
                            border: "none",
                            borderRadius: "50px",
                            padding: "10px 15px",
                            fontSize: "16px",
                            cursor: "pointer",
                            display: "flex",                            
                            alignItems: "center",
                            gap: "5px",
                        }}
                    >
                        <FaWhatsapp size={20} />

                    </button>
                    </div>                  
                </div>                                    
                
                }                               

            </div>
        ); 
    
    };

    const receberAudio = (valor) => {
        console.log('teste receber valor');
        console.log(valor);
        setAudioPlay(valor);
        playAudio(valor.mp3);
        setAudiocarregado(true);
    };  

    const toggleSidebar = () => {
        // event.preventDefault();
        console.log("Menu clicado!"); 
        console.log('teste event');
        
        // console.log(event);
        setIsSidebarVisible(!isSidebarVisible);
        setSubmenuvisible(!submenuvisible);
    };      

    const [isOpen, setIsOpen] = useState(false);

    const toggleSidebar2 = (event) => {
        event.preventDefault();
        setIsOpen((prev) => !prev);
      };

    let salvoLogHome= false;

    useEffect(() => {

        if (!salvoLogHome) {
            // salvarLog('count_home');
            salvoLogHome = true;
        }

        salvarLog('count_home');

    }, []);

    const [contador, setContador] = useState(0);

    const atualizarValor = (novoValor) => {
        setItemPlay(novoValor);        
        openModal();        
        playAudio(novoValor.mp3);
        setAudiocarregado(true);     
        salvarLog('count_palavra', novoValor.id);   
    };

    const [options, setOptions] = useState([]);
    const [convidados, setConvidados] = useState([]);

    async function optionsConvidados() {

        try {

            const config = {
                method: 'post',                
                url: baseurl,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 10000,
                data: {
                    'id': '',
                    'tipo': 'convidado',
                    'action': 'getpastores'
                }
            };

            const req = await axios(config).then((res) => {
                var temp = [];

                for (let i = 0; i < res.data.length; ++i) {
                    temp.push({ label: res.data[i].nome, id: res.data[i].id, link: "/services/web-development" });

                }         

                setConvidados(temp);

            }).catch((err) => {
                // optionsPastores();
            });
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('A solicitação foi cancelada devido a timeout');
                //   optionsPastores();
                // Aqui você pode fazer algo, como tentar novamente a consulta
                // ou exibir uma mensagem de erro para o usuário
            } else {
                // Lidar com outros erros de rede ou do servidor
                console.error('Erro:', error.message);
                throw error;
            }

        }


    }

    async function optionsPastores() {

        try {

            const config = {
                method: 'post',                
                url: baseurl,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 10000,
                data: {
                    'id': '',
                    'action': 'getpastores'
                }
            };

            const req = await axios(config).then((res) => {
                var temp = [];

                for (let i = 0; i < res.data.length; ++i) {
                    temp.push({ label: res.data[i].nome, id: res.data[i].id, link: "/services/web-development" });

                }         

                setOptions(temp);

            }).catch((err) => {
                // optionsPastores();
            });
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('A solicitação foi cancelada devido a timeout');
                //   optionsPastores();
                // Aqui você pode fazer algo, como tentar novamente a consulta
                // ou exibir uma mensagem de erro para o usuário
            } else {
                // Lidar com outros erros de rede ou do servidor
                console.error('Erro:', error.message);
                throw error;
            }

        }


    }

    useEffect(() => {        
        optionsPastores();
        optionsConvidados();
        if(especial != null){
            setEspecial(searchParams.get("especial"));
        }
    }, [especial])

    const menuOutrasPregacoes = [
        { label: 'Outras Pregações', id: busca, children: [
            { label: 'Buscar por palavra', id: busca,  onClick:"buscapalavra", link: "/services/web-development" }, 
            { label: 'POR QUE TEMOS QUE ACREDITAR NO PODER DA ORAÇÃO?', id: busca,  link: "/services/web-development" }
        ] }];

    const menuItems = [
        {
            label: "Tela Inicial",
            link: "/",
        },
        {
            label: "Pregador",
            children: options,
           
        },
        {
            label: "Convidados",
            children: convidados,            
        },
        // {
        //     label: "Outras Pregações",
        //     children: menuOutrasPregacoes,            
        // },
        // {
        //     children: [
        //             { label: "Geraldo Geremias", id:'teste', link: "/services/web-development" },
        //     ]
        // },

    ];

    const receberDados = (valor) => {  
        console.log('teste menu');
        console.log(valor);      
        setBusca(valor);
        setTipo('pastor');
        toggleSidebar();
    };

    const setItemMenu = (valor) => {  
        // console.log('teste menu');
        // console.log(valor);              
    };

    const receberData = (valor) => {       
        setData(valor);
        setTipo('data');
        toggleSidebar();
    };

    function handleSalvar(data) {      
        
        setTipo("busca_transcricao");
        setBusca_transcricao(data);
        setBusca('');
        closeModalBusca();
        
        console.log('teste data form');
        console.log(data);

    }

    function handleSalvarEntredadeVida(data) {    
        
        console.log(data);

       
        const config = {
            method: 'post',
            // url local
            // url: `https://doadordesangue.appsesites.com.br/ApiDoador.php?action=insert_doador`,
            // url: `ApiDoador.php?action=insert_doador`,
            url: baseurl,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 1000,
            data: {
                'id': null,
                'nome': data.nome,
                'celular': data.celular,                            
                'action': 'salvarentregasdevida'
            }
        };

        const req = axios(config).then((res) => {
            //   toast.success('Doação Cadastrada com Sucesso!', {              
            //     onClose: () =>  window.location.href = '/'
            //   })
            // window.location.href = '/';
            reset({
                nome: "",
                telefone: "",
                dtnascimento: "",
                tiposanguineo: ""
            })
            closeModalEntregue();


        });

        

    }

    function handleSalvarComentario(data) {    
        
        console.log(data);

       
        const config = {
            method: 'post',
            // url local
            // url: `https://doadordesangue.appsesites.com.br/ApiDoador.php?action=insert_doador`,
            // url: `ApiDoador.php?action=insert_doador`,
            url: baseurl,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 1000,
            data: {
                'id': null,
                'nome': data.nome,
                'celular': data.celular, 
                'descricao': data.descricao,                             
                'action': 'salvarcomentario'
            }
        };

        const req = axios(config).then((res) => {
            //   toast.success('Doação Cadastrada com Sucesso!', {              
            //     onClose: () =>  window.location.href = '/'
            //   })
            // window.location.href = '/';
            reset({
                nome: "",
                telefone: "",
                dtnascimento: "",
                tiposanguineo: ""
            })
            closeModalComentario();


        });

        

    }

    const MenuItem = ({ item, isOpen, onToggle, handleClick }) => {
        const hasChildren = item.children && item.children.length > 0;
      
        return (
          <li className="menu-item">
            
            <div onClick={onToggle}>
              {item.link ? <a href={item.link}>{item.label}</a> : item.label}
              
              {/* {hasChildren && <span>{isOpen ? "▲" : "▶"}</span>} */}
            </div>
            {hasChildren && isOpen && (
              <ul className="submenu">
                {item.children.map((child, index) => (
                  <li key={index} className="menu-item">
                    {child.link ? 
                    <a href="#"
                    onClick={(e) => {
                        e.preventDefault(); 
                        {child.onClick ?
                            handleClick(child.onClick)
                            :
                        handleClick(child.label)
                        }
                      }}
                    // href={child.link}
                    >{child.label}</a> : child.label}
                  </li>
                ))}
                
              </ul>
            )}
          </li>
          
        );
      };

    return (
        
<div className={orientation == 'landscape' ? 'scrollorno' : ''}>
        <div className={orientation == 'landscape' ? '' : "app"}>
            {/* Header */}

            <header ref={myRef} className={orientation == 'landscape' ? 'header-landscape' : "header"}>
                <div className='conteudo-header' style={{}}>
                    {/* <h1 className='title-app'>Podcast TIB Macaé</h1> */}

                    {/* Floating Button */}
                    <div style={ { display: 'flex', flexDirection: 'row' }}  >
                        <div style={{display:'flex', flexDirection:'row'}}>
                        <a className="toggle-btn" onClick={toggleSidebar}>
                            ☰                            
                        </a>
                        
                        </div>
                        <p className='title-menu'></p>
                        {/* <div className={`sidebar ${isSidebarVisible ? "visible" : ""}`}> */}
                        <div className={`sidebar ${isSidebarVisible ? "visible" : ""}`}>
                            <button className="close-btn" onClick={toggleSidebar}>
                                ✖
                            </button>
                            <Menu onClick={setItemMenu} submenuvisible={submenuvisible} onChange={receberDados} enviarDado={receberDados} enviarData={receberData} items={menuItems} />
                            <ul>
                            <div        
        style={{
          background: "#bcc44a",
          color: "white",
          padding: "10px",
          cursor: "pointer",
          textAlign: "center",
          borderRadius: "5px",
        }}
        onClick={openModalBusca}
      >
         Buscar Pregação
      </div>
      </ul>
      <ul>
                            <div        
        style={{
            backgroundImage: `url(${entregue})`,
            backgroundSize:'contain',
            backgroundRepeat:'no-repeat',
          color: "white",
          padding: "20px",
          cursor: "pointer",
          marginTop: '7%',
          textAlign: "center",
          borderRadius: "5px",
        }}
        onClick={openModalEntregue}
      >
         
      </div>

      <div        
        style={{
            background: "#88dce8",
            
          color: "white",
          padding: "10px",
          cursor: "pointer",
          marginTop: '7%',
          textAlign: "center",
          borderRadius: "5px",
        }}
        onClick={openModalComentario}
      >
         Deixe comentário
      </div>
      </ul>
      <ul className="menu">
      {/* <li class="menu-item"><div>Outras Pregações</div><ul class="submenu"><li class="menu-item"><a onClick={openModalBusca} href="#">teste</a></li></ul></li> */}
        
        {/* Descomentar o map para menu outras pregações */}

        {/* {menuOutrasPregacoes.map((menuOutrasPregacoes, index) => (
          <MenuItem
            key={index}
            item={menuOutrasPregacoes}
            isOpen={openIndex === index}
            handleClick={handleLinkClick}
            onToggle={() => toggleSubmenu(index)}
          />
          
        ))} */}
        
        <li className="menu-item">

          {/* <div style={{ width: "200px", margin: "0 auto" }}> */}
      {/* Botão ou item de menu */}

      {/* Descomentar a div para outro botão data da pregação */}

      {/* <div        
        style={{
          background: "#007bff",
          color: "white",
          padding: "10px",
          cursor: "pointer",
          textAlign: "center",
          borderRadius: "5px",
        }}
        onClick={openModal}
      >
         Data da Pregação
      </div> */}

      

      
    {/* </div> */}
        </li>
      </ul>

                        </div>

                    </div>

                    <h1 className='title-app'>Podcast TIB Macaé</h1>



                </div>
            </header>

            {/* Main Content */}
            <div className="content">
                <h2>Últimas Pregações</h2>
                {/* <h1>{windowSize.width}</h1>       
                <h1>/{windowSize.height}</h1>      */}
                 {/* <h1>/{window.screen.orientation}</h1>                     */}
                <div className="episodes">
                {/* <ComponenteBuscaAudio tipo={tipo} busca_transcricao={busca_transcricao} id={searchParams.get("id")} busca={busca} data={data} onClick={atualizarValor} enviarAudio={receberAudio} rssfeed="/feedpregacao.xml" /> */}
                    <ComponenteBuscaAudio tipo={tipo} busca_transcricao={busca_transcricao} id={searchParams.get("id")} especial={especial} busca={busca} data={data} onClick={atualizarValor} enviarAudio={receberAudio} rssfeed="/feedpregacao.xml"  />
                    <Modal isOpen={isModalOpen} onClose={closeModal} className="modal-overlay">
                    {itemPlay ?
                            <div style={{ width: '100%' }} className="">
                                <AudioPlayer src={currentAudio} itemPlay={itemPlay} /> 
                            </div>

                            : 'Carregando...'}
                            

                        {/* <h2>Conteúdo do Modal</h2>
        <p>Este é um exemplo de modal em React!</p> */}
                    </Modal>

                    <Modal isOpen={isModalOpenBusca} onClose={closeModalBusca} className="modal-overlay">
                        
                            {/* <div style={{ width: '20%' }} className=""> */}
                                <form style={{ display: 'flex', flexDirection:'column', alignSelf:'center', width:'100%'}} onSubmit={handleSubmit(data => handleSalvar(data))}>
                                
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                            <Controller
                                                                control={control}
                                                                name="palavra_transcricao"
                                                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                    <div style={{ display: 'flex', justifyContent:'center', alignItems:'center', flexDirection: 'column' }}>
                                                                        <label><h5>O pregador mencionou a palavra:</h5></label>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: '#FFF',
                                                                                width: '100%',
                                
                                                                                marginBottom: 15,
                                                                                color: '#222',
                                                                                fontSize: 14,
                                                                                borderRadius: 7,
                                                                                padding: 10
                                                                            }}
                                                                            onChange={onChange}
                                                                            onBlur={onBlur}
                                                                            selected={value}
                                
                                                                        />
                                                                    </div>
                                                                )}
                                                                defaultValue=""
                                                            />
                                
                                
                                                        </div>

                                                        
                                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '6%', alignItems: 'center', justifyContent: 'center' }}>
                                                            <input style={{
                                                                backgroundColor: '#59BFFF',
                                                                width: '100%',
                                                                height: 45,
                                                                marginBottom: 5,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                borderRadius: 7,
                                                                alignSelf: 'center',
                                                                width: '45%'
                                                            }} type="submit" />
                                                        </div>
                                
                                                    </form>
                            {/* </div> */}


                        {/* <h2>Conteúdo do Modal</h2>
        <p>Este é um exemplo de modal em React!</p> */}
                    </Modal>

                    <Modal style={{marginTop:windowSize.width < 480 ? '50%' : ''}} isOpen={isModalOpenEntregue} onClose={closeModalEntregue} className="modal-overlay">

                            <p style={{margin:0, padding:'0 0 20px 0', textAlign:'center'}}><h2 style={{margin:0, padding:0}}>Entrego minha vida ao Senhor</h2></p>
                        
                            {/* <div style={{ width: '20%' }} className=""> */}
                                <form style={{ display: 'flex', flexDirection:'column', alignSelf:'center', width:'100%'}} onSubmit={handleSubmit(data => handleSalvarEntredadeVida(data))}>
                                
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                            <Controller
                                                                control={control}
                                                                name="nome"
                                                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                    <div style={{ display: 'flex', justifyContent:'space-around', alignItems:'baseline', flexDirection: 'row' }}>
                                                                        <label style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}><h5 style={{alignSelf:'center'}}>Seu nome:</h5></label>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: '#FFF',
                                                                                width: '60%',
                                
                                                                                marginBottom: 15,
                                                                                color: '#222',
                                                                                fontSize: 14,
                                                                                borderRadius: 7,
                                                                                padding: 10
                                                                            }}
                                                                            onChange={onChange}
                                                                            onBlur={onBlur}
                                                                            selected={value}
                                
                                                                        />
                                                                    </div>
                                                                )}
                                                                defaultValue=""
                                                            />

<Controller
                                                                control={control}
                                                                name="celular"
                                                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                    <div style={{ display: 'flex', justifyContent:'space-around', alignItems:'baseline', flexDirection: 'row' }}>
                                                                        <label><h5>Contato:</h5></label>
                                                                        <InputMask
                                                                        mask="(99) 99999-9999"
            placeholder="(XX) XXXXX-XXXX"
                                                                            style={{
                                                                                backgroundColor: '#FFF',
                                                                                width: '60%',
                                
                                                                                marginBottom: 15,
                                                                                color: '#222',
                                                                                fontSize: 14,
                                                                                borderRadius: 7,
                                                                                padding: 10
                                                                            }}
                                                                            onChange={onChange}
                                                                            onBlur={onBlur}
                                                                            selected={value}
                                
                                                                        />
                                                                    </div>
                                                                )}
                                                                defaultValue=""
                                                            />
                                
                                
                                                        </div>

                                                        
                                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '6%', alignItems: 'center', justifyContent: 'center' }}>
                                                            <input style={{
                                                                backgroundColor: '#59BFFF',
                                                                width: '100%',
                                                                height: 45,
                                                                marginBottom: 5,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                borderRadius: 7,
                                                                alignSelf: 'center',
                                                                width: '45%'
                                                            }} type="submit" />
                                                        </div>
                                
                                                    </form>
                                                    <p style={{overflowY:'auto', height:'12vh', textAlign:'justify'}}>
                                                        <b>Aceitar Jesus como único e suficiente salvador é reconhecer que somos fracos, pecadores e que precisamos de um Salvador.</b> Quando aceitamos o sacrifício de Jesus, a nossa história muda: já não somos condenados a uma eternidade sem Deus, mas somos chamados Seus filhos e vamos viver para sempre no céu.

<p>Quem aceita Jesus se sujeita aos Seus mandamentos e escolhe viver uma vida de obediência. O ser humano só é verdadeiramente feliz quando recebe o amor de Deus através de Jesus Cristo!</p></p>
                            {/* </div> */}


                        {/* <h2>Conteúdo do Modal</h2>
        <p>Este é um exemplo de modal em React!</p> */}
                    </Modal>

                    <Modal style={{marginTop:windowSize.width < 480 ? '50%' : ''}} isOpen={isModalOpenComentario} onClose={closeModalComentario} className="modal-overlay">

                            <p style={{margin:0, padding:'0 0 20px 0', textAlign:'center'}}><h2 style={{margin:0, padding:0}}>Deixe seu comentário e sugestão</h2></p>
                        
                            {/* <div style={{ width: '20%' }} className=""> */}
                                <form style={{ display: 'flex', flexDirection:'column', alignSelf:'center', width:'100%'}} onSubmit={handleSubmit(data => handleSalvarComentario(data))}>
                                
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                            <Controller
                                                                control={control}
                                                                name="nome"
                                                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                    <div style={{ display: 'flex', justifyContent:'space-around', alignItems:'baseline', flexDirection: 'row' }}>
                                                                        <label style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}><h5 style={{alignSelf:'center'}}>Seu nome:</h5></label>
                                                                        <input
                                                                            style={{
                                                                                backgroundColor: '#FFF',
                                                                                width: '60%',
                                
                                                                                marginBottom: 15,
                                                                                color: '#222',
                                                                                fontSize: 14,
                                                                                borderRadius: 7,
                                                                                padding: 10
                                                                            }}
                                                                            onChange={onChange}
                                                                            onBlur={onBlur}
                                                                            selected={value}
                                
                                                                        />
                                                                    </div>
                                                                )}
                                                                defaultValue=""
                                                            />

<Controller
                                                                control={control}
                                                                name="celular"
                                                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                    <div style={{ display: 'flex', justifyContent:'space-around', alignItems:'baseline', flexDirection: 'row' }}>
                                                                        <label><h5>Contato:</h5></label>
                                                                        <InputMask
                                                                        mask="(99) 99999-9999"
            placeholder="(XX) XXXXX-XXXX"
                                                                            style={{
                                                                                backgroundColor: '#FFF',
                                                                                width: '60%',
                                
                                                                                marginBottom: 15,
                                                                                color: '#222',
                                                                                fontSize: 14,
                                                                                borderRadius: 7,
                                                                                padding: 10
                                                                            }}
                                                                            onChange={onChange}
                                                                            onBlur={onBlur}
                                                                            selected={value}
                                
                                                                        />
                                                                    </div>
                                                                )}
                                                                defaultValue=""
                                                            />

<Controller
                                                                control={control}
                                                                name="descricao"
                                                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                    <div style={{ display: 'flex', justifyContent:'space-around', alignItems:'baseline', flexDirection: 'row' }}>
                                                                        <label style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}><h5 style={{alignSelf:'center'}}>Comentário <br />/sugestão:</h5></label>
                                                                        <textarea
                                                                            style={{
                                                                                backgroundColor: '#FFF',
                                                                                width: '60%',
                                
                                                                                marginBottom: 15,
                                                                                color: '#222',
                                                                                fontSize: 14,
                                                                                borderRadius: 7,
                                                                                padding: 10
                                                                            }}
                                                                            onChange={onChange}
                                                                            onBlur={onBlur}
                                                                            selected={value}
                                
                                                                        />
                                                                    </div>
                                                                )}
                                                                defaultValue=""
                                                            />
                                
                                
                                                        </div>

                                                        
                                                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '6%', alignItems: 'center', justifyContent: 'center' }}>
                                                            <input style={{
                                                                backgroundColor: '#59BFFF',
                                                                width: '100%',
                                                                height: 45,
                                                                marginBottom: 5,
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                borderRadius: 7,
                                                                alignSelf: 'center',
                                                                width: '45%'
                                                            }} type="submit" />
                                                        </div>
                                
                                                    </form>
                                                    
                            {/* </div> */}


                        {/* <h2>Conteúdo do Modal</h2>
        <p>Este é um exemplo de modal em React!</p> */}
                    </Modal>

                </div>
            </div>

        </div>
        </div>
        
    );
}


export default Home2;